export const HOTEL_BOOK_BEFORE_PAYMENT_MESSAGE =
  "ההזמנה לספק נשלחת רק אחרי שהשרת אימת סליקה מלאה להזמנה הזו. מעבר לתשלום לא שולח הזמנה.";

export function refuseHotelSupplierBookBeforePayment() {
  return {
    supplierBook: false,
    networkBookCalled: false,
    message: HOTEL_BOOK_BEFORE_PAYMENT_MESSAGE,
  };
}
